module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center4"
  }), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_c('big', [_c('strong', [_vm._v("CALIGULA OF THE STARS")])])], 1), _vm._v(" "), _c('p', {
    staticClass: "block"
  }, [_vm._v("Though he was later accused of every crime and sexual perversion in the system, Hope Hubris began as an innocent. Because he defended his older sister against the violent lusts of a wealthy scion, Hope and his peasant family were forced to flee Callisto, one of the moons of Jupiter. Pursued by bloodthirsty scions across the airless desert, they barely escaped with their lives. The illegal space bubble was overcrowded with refugees, all hoping to reach Jupiter for asylum.")]), _vm._v(" "), _c('p', {
    staticClass: "block"
  }, [_vm._v("But the space travelers had not reckoned on the terrible threat of high space—the pirates, barbaric men who rape, rob, and murder, with no thought but to satisfy their bestial appetites. It will take all Hope’s ingenuity to survive, but the atrocities he witnesses will never die. There is only one way he can be rid of them…")]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_c('big', [_c('strong', [_vm._v("REVENGE")])])], 1), _vm._v(" "), _c('p', {
    staticClass: "break"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46cbec4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/front.vue
// module id = 72
// module chunks = 0